"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const data_1 = require("@@/assets/data");
const svgs_1 = require("@@/assets/svgs");
const detect_utils_1 = require("@/common/detect_utils");
const functions_1 = require("@/common/functions");
const components_1 = require("@/common/components");
const Button_1 = __importDefault(require("@mui/material/Button"));
const _1 = require(".");
function default_1({ signUpInputForm, }) {
    const [regionDialogOpen, setRegionDialogOpen] = (0, react_1.useState)(false);
    const closeDialog = () => setRegionDialogOpen(false);
    const selectedRegion = signUpInputForm.watch('region') || '';
    const currentLang = (0, detect_utils_1.currentLanguage)();
    const countries = currentLang === 'ko' ? data_1.countryKr : data_1.countryEn;
    const currentCountryObj = countries.find(obj => obj.value === selectedRegion);
    const currentCountryCode = (currentCountryObj === null || currentCountryObj === void 0 ? void 0 : currentCountryObj.value) || '';
    const currentCountryName = (currentCountryObj === null || currentCountryObj === void 0 ? void 0 : currentCountryObj.name) || '';
    const onRegionSelect = (region) => {
        selectedRegion !== region && signUpInputForm.setValue('region', region);
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(_1.SignUpEmailVerificationWrapper, { children: [(0, jsx_runtime_1.jsx)("h4", { children: t('배송 받는 국가') }), (0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ fullWidth: true, disableRipple: true, onClick: () => setRegionDialogOpen(true), sx: {
                            justifyContent: 'flex-start',
                            columnGap: '10px',
                            padding: '11px 14px',
                            borderRadius: '4px',
                            backgroundColor: 'var(--blue-10) !important',
                        } }, { children: [Boolean(currentCountryCode) && ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                                    position: 'relative',
                                    flexShrink: 0,
                                    display: 'flex',
                                    width: '20px',
                                    '&:after': (0, functions_1.afterImgWrapper)({ borderRadius: '2px' }),
                                } }, { children: (0, jsx_runtime_1.jsx)("img", { css: { width: '100%', borderRadius: '2px' }, alt: currentCountryName, src: `https://flagcdn.com/w20/${currentCountryCode.toLowerCase()}.webp`, srcSet: `https://flagcdn.com/w40/${currentCountryCode.toLowerCase()}.webp 2x` }) }))), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80", css: {
                                    paddingRight: '24px',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                } }, { children: currentCountryName })), (0, jsx_runtime_1.jsx)(svgs_1.ChevronDownSvg, { css: { position: 'absolute', right: '12px', width: '20px', height: '20px' } })] }))] }), (0, jsx_runtime_1.jsx)(components_1.RegionSelectDialog, { open: regionDialogOpen, closeDialog: closeDialog, countries: countries, selectedRegion: selectedRegion, onRegionSelect: onRegionSelect, titleText: t('배송 받는 국가를 선택해주세요'), guideTextEl: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('P-주소로 배송 받을 거에요'), (0, jsx_runtime_1.jsx)("span", { children: currentCountryName }), t('S-주소로 배송 받을 거에요')] }) })] }));
}
exports.default = default_1;
